<template>
  <div class="ras-select" :tabindex="tabindex" @blur="open = false">
    <div class="ras-select__selected" :class="{ open: open }" @click="open = !open">
      <span>{{ selected }}</span>
    </div>
    <div class="ras-select__items" :class="{ selectHide: !open }">
      <div
        v-for="(option, key) of options"
        :key="key"
        @click="makeSelection(key, option)">
        <span>{{ option }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },

  },
  data: () => ({
    selected: 'How old are you?',
    open: false,
  }),
  methods: {
    makeSelection(key, option) {
      this.selected = option;
      this.open = false;
      this.$emit('select', key);
    },
  },
  watch: {
    default(val) {
      this.selected = this.options[val]
    },
  },
}
</script>

<style lang="scss">

.ras-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 47px;
  line-height: 47px;

  &__selected {
    background-color: $c-inactive;
    font-family: $ff-heading;
    border: 1px solid transparent;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    user-select: none;

    @media (min-width: map_get($breakpoints, lg)) {
      font-size: 28px;
    }

    &::after {
      position: absolute;
      content: "";
      top: 22px;
      right: 1em;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-color: #fff transparent transparent transparent;
    }

    span {
      display: block;
      padding-left: 20px;
      margin-top: 3px;
    }

    &.open {
      border-color: $c-hover $c-hover transparent $c-hover;

      @media (min-width: map_get($breakpoints, lg)) and (max-height: map_get($v-breakpoints, sm)) {
        border-color: transparent $c-hover $c-hover $c-hover;
      }
    }
  }

  &__items {
    color: $black;
    overflow-y: scroll;
    border-right: 1px solid $c-hover;
    border-left: 1px solid $c-hover;
    border-bottom: 1px solid $c-hover;
    position: absolute;
    background-color: $white;
    left: 0;
    right: 0;
    z-index: 1;
    font-size: 15px;
    max-height: 150px;

    @media (min-width: map_get($breakpoints, lg)) {
      font-size: 18px;
      max-height: 300px;
    }

    @media (min-width: map_get($breakpoints, lg)) and (max-height: map_get($v-breakpoints, sm)) {
      max-height: 200px;
      bottom: 100%;
      border-top: 1px solid $c-hover;
      border-bottom: 0;
    }

    div {
      color: $black;
      padding-left: 35px;
      cursor: pointer;
      user-select: none;
      font-family: $ff-sans;

      &:hover {
        background-color: $c-hover;
        color: $white;
      }
    }
  }
}

.selectHide {
  display: none;
}
</style>